import PreProposals from "../../Pages/PreProposals";

const navigation = {
  header: "",
  links: [
    { text: "Pre Proposals", icon: <></>, route: "preproposals", component: PreProposals },
    
  ],
};
export default navigation;
